var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalEditBarang",
    attrs: {
      "id": "modal-edit-barang",
      "title": "Edit Barang",
      "variant": "success",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveBarang($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Uraian Barang"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Uraian Barang') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "name": "Uraian Barang",
      "placeholder": "...",
      "value": _vm.model('URAIAN_BARANG')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('URAIAN_BARANG', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Uraian Barang')),
      expression: "errors.has('Uraian Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Uraian Barang')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Satuan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Satuan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "name": "Jumlah Satuan",
      "placeholder": "...",
      "value": _vm.model('JML_SATUAN')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JML_SATUAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Satuan')),
      expression: "errors.has('Jumlah Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Satuan')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Satuan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Satuan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.satuan,
      "option-value": "JNS_SAT",
      "custom-text": function (item) { return ((item.JNS_SAT) + " - " + (item.UR_SAT)); },
      "value": _vm.model('JNS_SATUAN'),
      "name": "Jenis Satuan",
      "placeholder": "Jenis Satuan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JNS_SATUAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Satuan')),
      expression: "errors.has('Jenis Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Satuan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Kemasan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "placeholder": "...",
      "value": _vm.model('JML_KEMASAN'),
      "name": "Jumlah Kemasan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JML_KEMASAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')) + "\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Kemasan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.kemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); },
      "value": _vm.model('JNS_KEMASAN'),
      "name": "Jenis Kemasan",
      "placeholder": "Jenis Kemasan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JNS_KEMASAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Bruto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "...",
      "value": _vm.model('BRUTO')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('BRUTO', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Netto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "...",
      "value": _vm.model('NETTO')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('NETTO', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Barang (Rp)"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "currency": "Rp",
      "separator": ".",
      "decimal": "0",
      "value": _vm.model('CIF')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('CIF', $event)
      }
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "HS Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "8",
      "type": "text",
      "value": _vm.model('HS_CODE')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('HS_CODE', $event)
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("digit only")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif Bea Masuk"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1,
      "value": _vm.model('TARIF_BM')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('TARIF_BM', $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Bea Masuk"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_bm
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPN"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1,
      "value": _vm.model('TARIF_PPN')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('TARIF_PPN', $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPN"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_ppn
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPh"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1,
      "value": _vm.model('TARIF_PPH')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('TARIF_PPH', $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPh"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_pph
    }
  })], 1)], 1)]), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Simpan\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7b67e0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalEditBarang.vue
// module id = 359
// module chunks = 0